import { render, staticRenderFns } from "./baseInfoFeedback.vue?vue&type=template&id=ece0ed32&scoped=true"
import script from "./baseInfoFeedback.vue?vue&type=script&lang=js"
export * from "./baseInfoFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece0ed32",
  null
  
)

export default component.exports